<script lang="ts">
  import Button from "$lib/elements/Button.svelte";
  import {setCookie} from "$lib/utils/cookies";
  import {locale, translate} from "$lib/i18n";

  interface Props {
    acceptedCookies?: any;
  }

  let { acceptedCookies = $bindable(false) }: Props = $props();

  let acceptCookies = () => {
    acceptedCookies = true;
    setCookie('acceptedCookies', 'true', 365);
  }
</script>

{#if !acceptedCookies}
  <div id="cookies" class="flex flex-col gap-2 md:flex-row justify-center items-center fixed bottom-0 left-0 right-0 z-50 bg-primary-dark border-t border-primary-lightBlue text-white p-2 text-center">
    <p class="text-sm mr-2">{$translate('We use cookies to improve your experience. By using our website you are accepting our')}
    <a class="underline" href="/{$locale}/cookie-policy">Cookie Policy</a> {$translate('to improve your experience')}</p>
    <Button variant="secondary" on:click={acceptCookies}>{$translate('Accept')}</Button>
  </div>
{/if}
